// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__2qvf4","emails":"CreateEditClinics_emails__1LIzf","emailTagLabel":"CreateEditClinics_emailTagLabel__2zUIc"};